var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBebe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_3",
    "data-name": "Calque 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da0021;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.64,499.16A157.08,157.08,0,0,0,406.28,342.52v-174a156.64,156.64,0,0,0-313.28,0v174A157.08,157.08,0,0,0,249.64,499.16ZM285,361l-17,24.42a21.75,21.75,0,0,1-35.85,0l-17.4-26.1a21.76,21.76,0,1,1,35.76-24.81h0a21.77,21.77,0,0,1,35.77,24.81h0ZM211.26,71.44a3,3,0,0,1,3.82,1.73,3.2,3.2,0,0,1,.19,1.06h0a24.54,24.54,0,0,0,24.45,24.45H260a24.54,24.54,0,0,0,24.45-24.45,3,3,0,0,1,2.94-3,3.16,3.16,0,0,1,1.06.19,104.41,104.41,0,1,1-77.19,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195,170.65a3,3,0,0,1,4.09-.87,2.89,2.89,0,0,1,.87.87,8.7,8.7,0,0,0,13.22-11.32,8.52,8.52,0,0,0-.95-1,21.41,21.41,0,0,0-29.59,0A8.7,8.7,0,1,0,194,171.6a7.75,7.75,0,0,0,1-.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.27,215.9a45.94,45.94,0,0,0,64.83,0,8.7,8.7,0,0,0-11.32-13.22,8.52,8.52,0,0,0-.95.95,28.45,28.45,0,0,1-40.2,0,8.7,8.7,0,0,0-12.27,12.27Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.42,170.65a3,3,0,0,1,4.09-.87,3,3,0,0,1,.87.87,8.7,8.7,0,0,0,13.22-11.32,8.52,8.52,0,0,0-1-1,21.41,21.41,0,0,0-29.59,0,8.7,8.7,0,1,0,11.32,13.22,8.52,8.52,0,0,0,.95-.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBebe);
export default __webpack_public_path__ + "static/media/bebe.6f21b97c.svg";
export { ForwardRef as ReactComponent };